/** İstanbul Rotaract — görsel ve site adresi. Metinler i18n: `istanbulRotaract.*`. */

export const ISTANBUL_ROTARACT_IMAGE_SRC =
    'https://istanbulrotary.org/img/db/adsz-1.jpg';

export const ISTANBUL_ROTARACT_WEBSITE_HREF = 'https://www.istanbulrotaract.org';

/**
 * @param {unknown} raw
 * @returns {{ term: string, name: string }[]}
 */
export function mapIstanbulRotaractPastRows(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
        .filter((x) => x && typeof x === 'object')
        .map((x) => {
            const o = /** @type {{ term?: unknown, name?: unknown }} */ (x);
            return {
                term: String(o.term ?? ''),
                name: String(o.name ?? ''),
            };
        })
        .filter((r) => r.term && r.name);
}

/**
 * @param {unknown} raw
 * @returns {{ term: string, name: string }}
 */
export function parseIstanbulRotaractCurrentPresident(raw) {
    if (!raw || typeof raw !== 'object') return { term: '', name: '' };
    const o = /** @type {{ term?: unknown, name?: unknown }} */ (raw);
    return {
        term: String(o.term ?? ''),
        name: String(o.name ?? ''),
    };
}
